import React, { Component } from "react";
import NavBar from "../navbar/NavBar"
import Footer from "../footer/Footer"
import CalBlue from '../../assets/Image/CaliforniaBlue.png'
import USA from '../../assets/Image/USA.png'
import InternationalBlue from '../../assets/Image/InternationalBlue.png'

// Import news data from JSON files
import CAL_NEWS from './CAL_NEWS.json';
import US_NEWS from './US_NEWS.json';
import GLOBAL_NEWS from './GLOBAL_NEWS.json';

const EXPAND_SCALER = 7;

class News extends Component {
    constructor(props) {
        super(props);
        this.path = '/news';
        let { state } = this.props.location;
        let title = null;
        if (this.props.match.params.country){
            title = this.props.match.params.country;
        }
        if (state) {
            title = state.title
        }
        this.state = {
            title: title == null ? 'ca' : title,
            data: {},
            image: CalBlue,
            renderData: [],
            /**
             * 
             * The expanded object stores the current expand index for each year
             * e.g. { '2020': 3, '2019': 1 }
             * 
             * The value of each key has the following values:
             * n (n >= 1) stands for normal unit expand scale
             * 0 means the current data length is less than the ${EXPAND_SCALER}
             * -1 means the current data is fully expanded
             */
            expanded: {}
        }
    }

    componentWillMount() {}

    componentDidMount() {
        this.handleChangeTab(this.state.title)
        this.scrollToTop();
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    handleChangeTab = (param) => {
        this.props.history.replace({ pathname: '/news/' + param, state: { title: param } });
        let data = CAL_NEWS;
        let image = CalBlue;
        let expanded = {};
        let renderData = {};
        switch(param) {
            case 'ca':
                data = CAL_NEWS;
                image = CalBlue;
                break;
            case 'us':
                data = US_NEWS;
                image = USA;
                break;
            case 'global':
                data = GLOBAL_NEWS;
                image = InternationalBlue;
                break;
        }
        // Initialize the expand-data
        // expanded[2021] = false, 2021 cal news doesn't need "show all" option
        Object.keys(data).forEach(element => {
            expanded[element] = data[element].length > EXPAND_SCALER;
            renderData[element] = data[element].slice(0, EXPAND_SCALER);
        });
        
        this.setState({
            title: param,
            data: data,
            image: image,
            expanded: expanded,
            renderData: renderData
        });
    }

    /**
     * Expand the news one time, appending {EXPAND_SCALER} news to the end
     */
    handleExpandContent = (year) => {
        if (this.state.expanded[year] < 0) {
            return;
        }
        const { data } = this.state;
        // Process expand operation
        this.setState((prevState) => {
            let expanded = Object.assign({}, prevState.expanded);
            let renderData = Object.assign({}, prevState.renderData);

            expanded[year] += 1;
            let newData = data[year].slice((expanded[year] - 1) * EXPAND_SCALER, (expanded[year]) * EXPAND_SCALER);
            console.log(newData)
            renderData[year] = [...renderData[year], ...newData];
            console.log(renderData)
            if (newData.length < EXPAND_SCALER) {
                expanded[year] = -1;
            }
            return {
                expanded: expanded,
                renderData: renderData
            }
        })
    }

    /**
     * Expand all the news
     */
    handleExpandAllContent = (year) => {
        if (this.state.expanded[year] < 0) {
            return;
        }
        const { data } = this.state;
        // Process expand-all operation
        this.setState((prevState) => {
            let expanded = Object.assign({}, prevState.expanded);
            let renderData = Object.assign({}, prevState.renderData);
            expanded[year] = -1;
            renderData[year] = data[year];
            return {
                expanded: expanded,
                renderData: renderData
            }
        })
    }

    /**
     * Collapse all the news
     */
    handleCollapseAllContent = (year) => {
        const { data } = this.state;
        // Process collapse-all operation
        this.setState((prevState) => {
            let expanded = Object.assign({}, prevState.expanded);
            let renderData = Object.assign({}, prevState.renderData);
            expanded[year] = data[year].length > EXPAND_SCALER;
            renderData[year] = data[year].slice(0, 1 * EXPAND_SCALER);
            return {
                expanded: expanded,
                renderData: renderData
            }
        })
    }

    render() {
        const { title, renderData, expanded, image } = this.state;
        return (
            <div>
                <NavBar path={this.path} handler={this.handleChangeTab}/>
                <div className="container1">
                    <div className="row">
                        <div className="col-sm-3 submenu-tabs">
                            <button onClick={() => this.handleChangeTab('ca')} className={title == 'ca' ? "news-active-tab first-tab" : "news-tab first-tab"}><span>California News </span></button>
                            <button onClick={() => this.handleChangeTab('us')} className={title == 'us' ? "news-active-tab mt-3" : "news-tab mt-3"}><span>USA News </span></button>
                            <button onClick={() => this.handleChangeTab('global')} className={title == 'global' ? "news-active-tab mt-3" : "news-tab mt-3"}><span>International News </span></button>
                        </div>
                        <div className="col-sm-6">
                            <div className="typing">
                                <h5><br/><br/><br/><br/><br/><br/>See what's happening in Nanotech...</h5>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <img className="img-fluid mx-auto d-block news-image" src={image} alt="Image"/>
                        </div>
                    </div>
                    {
                        Object.keys(renderData).sort().reverse().map((year, i) => {
                            const currentYear = renderData[year];   // top ~7 news of the year
                            let showAll = expanded[year] == 1;
                            return (
                                <div key={i}>
                                    <div className="mt-5 mb-5 row">
                                        <h4 className="news-title">{year}</h4>
                                        {
                                            expanded[year] ? (
                                                <button onClick={() => showAll ? this.handleExpandAllContent(year) : this.handleCollapseAllContent(year)} 
                                                        type="button" 
                                                        className="btn btn-link">
                                                    { showAll ? 'Show All' : 'Collapse All' }
                                                </button>
                                            ) : (<span></span>)
                                        }
                                    </div>

                                    <table className="mb-5">
                                        <thead>
                                        <tr>
                                            <th width="10%">Date</th>
                                            <th width="25%">Title</th>
                                            <th width="10%">Place</th>
                                            <th width="35%">Description</th>
                                            <th width="10%">Link</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentYear.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.date}</td>
                                                            <td>
                                                                {item.name}
                                                            </td>
                                                            <td>{item.place}</td>
                                                            <td>
                                                                {
                                                                    item.description.split("\n").map((item, idx) => (
                                                                        <p key={idx}>{item}</p>
                                                                    ))
                                                                }
                                                            </td>
                                                            <td>  
                                                                {
                                                                    item.link == '' || item.link.length < 1 ?
                                                                    <span></span>
                                                                    :
                                                                    <a href={item.link}>
                                                                        <button className="read-more-button">Read More</button>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>

                                    </table>
                                    {
                                        expanded[year] > 0 ?
                                        (<div className="load-container mt-5 mb-5">
                                            <button onClick={() => this.handleExpandContent(year)} 
                                                    type="button" 
                                                    className="btn btn-primary">
                                                    Load More
                                            </button>
                                        </div>) :
                                        (<div></div>)
                                    }
                                </div>
                            )
                        })
                    }
                
                    <a onClick={() => {this.scrollToTop()}} className="text-center"><p><span className="news-back-to-top">Back to Top</span><br/><br/><br/></p></a>
                </div> 5
                <Footer/>
            </div>
        );
    }
}

export default News;
